import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../context/userContext";
import { postData } from "../fetchRoutes/postData";
import NavItem from "../props/sellerNavItemProp";

export default function SellerMobileSidebar() {
  const { isLoggedIn, setIsLoggedIn, userDetails, setUserDetails } = useContext(UserContext);
  const logoutUrl = process.env.REACT_APP_LOGOUT_USER;

  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const response = await postData(logoutUrl, userDetails);
      if (response.status === "success") {
        setTimeout(() => {
          setIsLoggedIn(false);
          setUserDetails({ name: "", email: "", username: "", role: "" });
        }, 500);
      }
    } catch (err) {
      console.error("Error checking auth:", err);
      alert("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const role = userDetails?.role || "guest";

  const getNavLinks = (role) => {
    const commonLinks = [{ to: "/", iconClass: "homeIcon", label: "Home" }];
    const roleBasedLinks = {
      buyer: [
        { to: "/buyer/dashboard", iconClass: "dashboardIcon", label: "Dashboard" },
        { to: "/buyer/favorite-properties", iconClass: "favoritesIcon", label: "Favorites" },
        { to: "/buyer/my-bids", iconClass: "propertyIcon", label: "My Bids" },
        { to: "/buyer/update-details", iconClass: "updateIcon", label: "My Details" },
        { to: "/buyer/won-properties", iconClass: "trophyIcon", label: "My Properties" },
      ],
      seller: [
        { to: "/seller/dashboard", iconClass: "dashboardIcon", label: "Dashboard" },
        { to: "/seller/add-property", iconClass: "addPropertyIcon", label: "Add Property" },
        { to: "/seller/my-properties", iconClass: "propertyIcon", label: "My Properties" },
        { to: "/seller/update-details", iconClass: "updateIcon", label: "Update Detail" },
        { to: "/seller/chat", iconClass: "chatIcon", label: "Live Chat" },
      ],
      admin: [
        { to: "/admin/dashboard", iconClass: "dashboardIcon", label: "Dashboard" },
        { to: "/admin/users", iconClass: "usersIcon", label: "Manage Users" },
        { to: "/admin/properties", iconClass: "manageIcon", label: "Manage Auction" },
        { to: "/admin/payments", iconClass: "paymentsIcon", label: "Payments" },
      ],
    };
    return [...commonLinks, ...(roleBasedLinks[role] || [])];
  };

  const navLinks = getNavLinks(role);

  return (
    <>
        {/* Arrow toggle "pull tab" */}
        <div
        className={`arrowToggle ${isOpen ? "rotate" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        >
        <span className="arrow">&#x25B6;</span> {/* ▶ */}
        </div>




        {isOpen && (
            <nav className="sellerNavigation open">
            {isLoading ? (
                <div className="loaderContainer">
                <div className="loader"></div>
                <p className="loadingText">Logging out...</p>
                </div>
            ) : (
                <>
                <div className="sidebar">
                    <div className="logo"></div>
                    <div className="companyName">
                    <Link to="/" className="navLink nameNavLink navName phoneNavLink navMobile">BidBrick</Link>
                    </div>
                </div>

                <div className="navigation dashboardNavigation">
                    <div className="mainLinks">
                    <ul>
                        {navLinks.map((link, index) => (
                        <NavItem key={index} {...link} />
                        ))}
                    </ul>
                    </div>

                    <div className="secondaryLinks">
                    <ul>
                        {isLoggedIn && (
                        <NavItem to="/" iconClass="logoutIcon" label="Logout" onClick={handleLogout} />
                        )}
                    </ul>
                    </div>
                </div>
                </>
            )}
            </nav>
        )}
    </>
  );
}
